'use client'

import { useState } from 'react'
import { Button } from '@ui/primitives/Button'
import { Modal } from '@/_ui/composites'
import { TablatureHelp } from '@/components/tablatures/tablature'
import { useServerTranslations } from '@/lib'

interface HelpButtonProps {
    dictionary: Record<string, string>
}

export function HelpButton({ dictionary }: HelpButtonProps) {
    const [isOpen, setIsOpen] = useState(false)
    const { t } = useServerTranslations(dictionary)

    return (
        <>
            <Button
                onClick={() => setIsOpen(true)}
                variant="ghost"
                size="md"
                className="transition-colors duration-200 text-gray-500 hover:text-blue-500 hover:bg-blue-50"
                title={t('tablatures.help.modal_title')}
            >
                <i className="fa-solid fa-circle-question mr-2 text-gray-400 group-hover:text-blue-500" />
                <span className="hidden sm:inline font-medium">
                    {t('common.help')}
                </span>
            </Button>

            <Modal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                title={t('tablatures.help.modal_title')}
                size="lg"
            >
                <TablatureHelp />
            </Modal>
        </>
    )
}
